import { useQuery } from '@apollo/client';
import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import PopOver from '../../components/deprecated/PopOver';
import { gql } from '../../graphql/generated/gql';
import addTestId from '../../utils/addTestId';
import { PostPolicyAction, usePostPolicyCheck } from '../postPolicyCheck';
import {
  useAddGroupToPost,
  useAddPostUser,
  useAddTopicToPost,
} from './postPermissionOperations';
import * as styles from './SharingDropdown.module.scss';
import SharingDropdownAccessList from './SharingDropdownAccessList';
import SharingDropdownAddSelect from './SharingDropdownAddSelect';
import SharingDropdownLink from './SharingDropdownLink';

const SHARING_DROPDOWN_QUERY = gql(/** @complexity 5 */ `
  query SharingDropdown($postId: ID!) {
    post(id: $postId) {
      id
      ...SharingDropdownAccessList_post
      ...SharingDropdownLink_post
      ...useAddPostUser_post
      ...usePostPolicyCheck_post
      ...SharingDropdownAddSelect_post
    }
  }
`);

interface SharingDropdownProps {
  close: () => void;
  postId: string;
}

const SharingDropdown = ({ close, postId }: SharingDropdownProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const postPolicyCheck = usePostPolicyCheck();

  const addTopic = useAddTopicToPost();
  const addUser = useAddPostUser();
  const addGroup = useAddGroupToPost();

  const { data } = useQuery(SHARING_DROPDOWN_QUERY, { variables: { postId } });

  const post = data?.post;

  if (!post) {
    return null;
  }

  const canEdit = postPolicyCheck(PostPolicyAction.EditPost, post, currentUser);

  return (
    <PopOver.Container
      close={close}
      noPadding
      width="auto"
      mobileTitle="Share"
      fullHeight
    >
      <div {...addTestId('sharingDropdown')} className={styles.container}>
        {canEdit && (
          <div className={styles.addContainer}>
            <SharingDropdownAddSelect
              post={post}
              onAddTopic={(topicId: string) => addTopic(post.id, topicId)}
              onAddUser={(userId: string) => addUser(post, userId)}
              onAddGroup={(groupId: string) => addGroup(post.id, groupId)}
            />
          </div>
        )}
        <div
          className={styles.userContainer}
          {...addTestId('sharingDropdownUserContainer')}
        >
          <SharingDropdownAccessList post={post} />
        </div>
        <div className={styles.linkContainer}>
          <SharingDropdownLink post={post} onPricingModalOpen={close} />
        </div>
      </div>
    </PopOver.Container>
  );
};

export default SharingDropdown;
